export default __webpack_public_path__ + "static/media/news (3).7f2e5037.webp";